'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _apolloClient = require('../../apolloClient');

var _apolloClient2 = _interopRequireDefault(_apolloClient);

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _booking = require('./booking');

var _booking2 = _interopRequireDefault(_booking);

var _select = require('./select');

var _select2 = _interopRequireDefault(_select);

var _alert = require('./alert');

var _alert2 = _interopRequireDefault(_alert);

var _modal = require('./modal');

var _modal2 = _interopRequireDefault(_modal);

var _action = require('./action');

var _action2 = _interopRequireDefault(_action);

var _reset = require('./reset');

var _reset2 = _interopRequireDefault(_reset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  apollo: _apolloClient2.default.reducer(),
  reduxAsyncConnect: _reduxAsyncConnect.reducer,
  auth: _auth2.default,
  booking: _booking2.default,
  select: _select2.default,
  alert: _alert2.default,
  modal: _modal2.default,
  action: _action2.default,
  reset: _reset2.default
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reducer.js
// module id = 876
// module chunks = 0